var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#505050",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.721 17.2-1.696.891c-1.074.565-2.33-.347-2.125-1.544l.659-3.837a1.136 1.136 0 0 0-.327-1.005L1.444 8.987c-.87-.847-.39-2.323.811-2.498l3.854-.56c.37-.054.69-.286.855-.621l1.723-3.492c.537-1.088 2.089-1.088 2.626 0l1.723 3.492c.166.335.486.567.855.621l3.854.56c1.2.175 1.68 1.65.811 2.498l-.25.244",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.255 8.5 1.023 2.072a.674.674 0 0 0 .508.369l2.287.332a.87.87 0 0 1 .482 1.483L16.9 14.369a.674.674 0 0 0-.194.597l.39 2.278a.87.87 0 0 1-1.26.917l-2.047-1.076a.674.674 0 0 0-.627 0l-2.046 1.076a.87.87 0 0 1-1.261-.917l.39-2.278a.675.675 0 0 0-.194-.597l-1.655-1.613a.87.87 0 0 1 .482-1.483l2.287-.332c.22-.032.41-.17.508-.37L12.696 8.5a.87.87 0 0 1 1.56 0Z"
  }))));
};
export default SvgStar;